import React, { Suspense } from 'react';
import ALink from '../utils/alink';
import MainMenu from '../menu/main-menu';
import CartMenu from '../cart/cart-menu';
import HomeSearch from '../search/home-searchbox';

function Header() {
  // Access environment variables for header configuration
  const headerSrc = process.env.REACT_APP_S3_BUCKET +process.env.REACT_APP_HEADER_SRC  || "/default-logo.png";
  const headerAltText = process.env.REACT_APP_HEADER_ALT_TEXT || "Logo";
  const headerWidth = process.env.REACT_APP_HEADER_WIDTH || 200;
  const headerHeight = process.env.REACT_APP_HEADER_HEIGHT || 100;

  const showMobileMenu = () => {
    document.querySelector('body').classList.add('mmenu-active');
  }
  return (
    <header className="header hide-on-print">
      <div className="header-middle sticky-header fix-top sticky-content">
        <div className="container">
          <div className="header-left">
            <ALink href="#" className="mobile-menu-toggle" onClick={showMobileMenu}>
              <i className="d-icon-bars2"></i>
            </ALink>
            <ALink href="/" className="logo">
              <Suspense fallback={<div>Loading...</div>}>
                <img 
                  src={headerSrc} 
                  alt={headerAltText} 
                  width={headerWidth} 
                  height={headerHeight} 
                />
              </Suspense>
            </ALink>
            <HomeSearch />
          </div>
          <div className="header-right">
            <CartMenu />
          </div>
        </div>
      </div>
      <div className="header-bottom d-lg-show">
        <div className="container">
          <div className="header-left">
            <MainMenu />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
